import { Routes } from '@angular/router';
import { LoginComponent } from '@app/auth/login/login.component';
import { SignupComponent } from '@app/auth/signup/signup.component';
import { ResetPasswordComponent } from '@app/auth/reset-password/reset-password.component';
import { authGuard } from '@app/auth/auth.guard';
import { LoadsComponent } from './loads/loads/loads.component';
import { TrucksComponent } from './trucks/trucks/trucks.component';
import { UserSettingsComponent } from '@app/account/user-settings/user-settings.component';
import { AccountComponent } from '@app/account/account.component';
import { ConnectionsComponent } from '@app/account/connections/connections.component';
import { UserNameChangeComponent } from './account/user-name-change/user-name-change.component';
import { UserEmailChangeComponent } from './account/user-email-change/user-email-change.component';
import { UserCellPhoneChangeComponent } from './account/user-cell-phone-change/user-cell-phone-change.component';
import { UserPasswordChangeComponent } from './account/user-password-change/user-password-change.component';
import { UserDeleteComponent } from './account/user-delete/user-delete.component';
import { ConnectionComponent } from './account/connection/connection.component';
import { LoadSearchesComponent } from './loads/load-searches/load-searches.component';
import { LoadSearchComponent } from './loads/load-search/load-search.component';
import { TruckSearchComponent } from './trucks/truck-search/truck-search.component';
import { TruckSearchesComponent } from './trucks/truck-searches/truck-searches.component';
import { LoadViewPublicComponent } from './loads/load-view-public/load-view-public.component';
import { TruckViewPublicComponent } from './trucks/truck-view-public/truck-view-public.component';
import { SavedLoadsComponent } from './loads/saved-loads/saved-loads.component';
import { SavedTrucksComponent } from './trucks/saved-trucks/saved-trucks.component';
import { UserAdditionalEmailAddComponent } from './account/user-additional-email-add/user-additional-email-add.component';
import { UserDirectPhoneChangeComponent } from './account/user-direct-phone-change/user-direct-phone-change.component';
import { ApiDocumentationComponent } from './pages/api-documentation/api-documentation.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';

export const routes: Routes = [
  // Public
  {
    path: '',
    component: LoginComponent,
    canActivate: [authGuard],
    data: { title: 'Wide & Heavy', hideHeader: true },
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [authGuard],
    data: { title: 'Login', hideHeader: true },
  },
  {
    path: 'signup',
    component: SignupComponent,
    canActivate: [authGuard],
    data: { title: 'Signup', hideHeader: true },
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [authGuard],
    data: { title: 'Forgot Password', hideHeader: true },
  },
  {
    path: 'pages/api-documentation',
    component: ApiDocumentationComponent,
    data: { title: 'API Documentation', hideHeader: true },
  },
  {
    path: 'pages/privacy-policy',
    component: PrivacyPolicyComponent,
    data: { title: 'Privacy Policy', hideHeader: true },
  },
  {
    path: 'pages/terms-of-service',
    component: TermsOfServiceComponent,
    data: { title: 'Terms of Service', hideHeader: true },
  },

  // Account
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [authGuard],
    data: { title: 'Account' },
  },
  {
    path: 'account/settings',
    component: UserSettingsComponent,
    canActivate: [authGuard],
    data: { title: 'Settings' },
  },
  {
    path: 'account/connections',
    component: ConnectionsComponent,
    canActivate: [authGuard],
    data: { title: 'Connections' },
  },
  {
    path: 'account/connection',
    component: ConnectionComponent,
    canActivate: [authGuard],
    data: { title: 'Connection' },
  },
  {
    path: 'account/name',
    component: UserNameChangeComponent,
    canActivate: [authGuard],
    data: { title: 'Name Change' },
  },
  {
    path: 'account/email',
    component: UserEmailChangeComponent,
    canActivate: [authGuard],
    data: { title: 'Email Change' },
  },
  {
  path: 'account/additional-email',
    component: UserAdditionalEmailAddComponent,
    canActivate: [authGuard],
    data: { title: 'Add Additional Email' },
  },
  {
    path: 'account/cell-phone',
    component: UserCellPhoneChangeComponent,
    canActivate: [authGuard],
    data: { title: 'Cell Phone Change' },
  },
  {
    path: 'account/direct-phone',
    component: UserDirectPhoneChangeComponent,
    canActivate: [authGuard],
    data: { title: 'Direct Phone Change' },
  },
  {
    path: 'account/password',
    component: UserPasswordChangeComponent,
    canActivate: [authGuard],
    data: { title: 'Password Change' },
  },
  {
    path: 'account/delete',
    component: UserDeleteComponent,
    canActivate: [authGuard],
    data: { title: 'Delete Account' },
  },

  // Loads
  {
    path: 'loads',
    component: LoadsComponent,
    canActivate: [authGuard],
    data: { title: 'My Loads' },
  },
  {
    path: 'loads/searches',
    component: LoadSearchesComponent,
    canActivate: [authGuard],
    data: { title: 'Load Searches' },
  },
  {
    path: 'loads/searches/:id',
    component: LoadSearchComponent,
    canActivate: [authGuard],
    data: { title: 'Load Search' },
  },
  {
    path: 'loads/saved',
    component: SavedLoadsComponent,
    canActivate: [authGuard],
    data: { title: 'Saved Loads' },
  },
  {
    path: 'loads/view/:id',
    component: LoadViewPublicComponent,
    canActivate: [authGuard],
    data: { title: 'Load View', hideHeader: true },
  },

  // Trucks
  {
    path: 'trucks',
    component: TrucksComponent,
    canActivate: [authGuard],
    data: { title: 'My Trucks' },
  },
  {
    path: 'trucks/searches',
    component: TruckSearchesComponent,
    canActivate: [authGuard],
    data: { title: 'Truck Searches' },
  },
  {
    path: 'trucks/searches/:id',
    component: TruckSearchComponent,
    canActivate: [authGuard],
    data: { title: 'Truck Search' },
  },
  {
    path: 'trucks/saved',
    component: SavedTrucksComponent,
    canActivate: [authGuard],
    data: { title: 'Saved Trucks' },
  },
  {
    path: 'trucks/view/:id',
    component: TruckViewPublicComponent,
    canActivate: [authGuard],
    data: { title: 'Truck View', hideHeader: true },
  },

  // Fallback
  {
    path: '**',
    redirectTo: 'loads',
  },
];